import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ComponentFactoryResolver,
  ComponentRef,
  SimpleChanges,
} from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  CommunityDto,
  CurrencyDto,
  CorrespondenceActionPartyDto,
  CorrespondenceCompanyDto,
  CorrespondenceDepartmentFunctionDto,
  CorrespondenceRequestCategoryDto,
  CorrespondenceIssuedCategoryDto,
  CorrespondenceCommunityDto,
  CorrespondenceTeamDto,
} from '@cradua/data';
import { CountryViewComponent } from '../../components/country-view/country-view.component';
import { StateViewComponent } from '../../components/state-view/state-view.component';
import { LgaViewComponent } from '../../components/lga-view/lga-view.component';
import { CommunityViewComponent } from '../../components/community-view/community-view.component';
import { ActionPartyViewComponent } from '../../components/action-party-view/action-party-view.component';
import { CurrencyViewComponent } from '../../components/currency-view/currency-view.component';
import { FunctionViewComponent } from '../../components/function-view/function-view.component';
import { CompanyViewComponent } from '../../components/company-view/company-view.component';
import { TeamViewComponent } from '../../components/team-view/team-view.component';
import { RequestCategoryViewComponent } from '../../components/request-category-view/request-category-view.component';
import { IssuedCategoryViewComponent } from '../../components/issued-category-view/issued-category-view.component';
import { CorrespondenceReference } from '../../models/correspondence.interface';
import { CorrespondenceFormDirective } from '../../directives/correspondence-form.directive';

const componentMapper = {
  country: CountryViewComponent,
  state: StateViewComponent,
  lga: LgaViewComponent,
  currency: CurrencyViewComponent,
  community: CommunityViewComponent,

  actionParty: ActionPartyViewComponent,
  function: FunctionViewComponent,
  company: CompanyViewComponent,
  team: TeamViewComponent,
  requestCategory: RequestCategoryViewComponent,
  issuedCategory: IssuedCategoryViewComponent,
};

@Component({
  selector: 'mrsoftapps-correspondence-form-container',
  templateUrl: './correspondence-form-container.component.html',
  styleUrls: ['./correspondence-form-container.component.css'],
})
export class CorrespondenceFormContainerComponent implements OnInit {
  @ViewChild(CorrespondenceFormDirective, { static: true })
  placeholder: CorrespondenceFormDirective;

  @Input() data: any;
  inputData: CorrespondenceReference;
  @Input() countries: CountryDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() communities: CommunityDto[];
  @Input() currencies: CurrencyDto[];

  @Input() actionParties: CorrespondenceActionPartyDto[];
  @Input() companies: CorrespondenceCompanyDto[];
  @Input() functions: CorrespondenceDepartmentFunctionDto[];
  @Input() requestCategories: CorrespondenceRequestCategoryDto[];
  @Input() issuedCategories: CorrespondenceIssuedCategoryDto[];
  @Input() teams: CorrespondenceTeamDto[];

  @Output() changeEmit: EventEmitter<string> = new EventEmitter<string>();
  @Output() deleteEvent: EventEmitter<string> = new EventEmitter<string>();

  componentRef: ComponentRef<any>;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    /**
     * We are using this hook for change detection and invoking loadComponent() method
     * There are more ways to do this but for the simplicity of this example I have decided on this way
     */
    if (changes.data) {
      if (changes.data.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.states) {
      if (changes.states.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.lgas) {
      if (changes.lgas.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.actionParties) {
      if (changes.actionParties.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.requestCategories) {
      if (changes.requestCategories.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.issuedCategories) {
      if (changes.issuedCategories.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.communities) {
      if (changes.communities.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.companies) {
      if (changes.companies.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.teams) {
      if (changes.teams.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.functions) {
      if (changes.functions != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.currencies) {
      if (changes.currencies.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    }
  }

  /**
   * A method that loads and creates instances of components
   */
  loadComponent() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    /** Preparing our component for creation */
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      componentMapper[this.data]
    );
    /** Grabbing reference of our view placeholder */
    const viewContainerRef = this.placeholder.viewContainerRef;
    /** Clearing our placeholder  */
    viewContainerRef.clear();
    /** Magic of creating a component instance  */
    this.componentRef = viewContainerRef.createComponent(componentFactory);
    /**
     * @Input data into our instance.
     */
    // (this.componentRef.instance as StudentListView).student = this.inputData.student;
    if (this.data === 'country') {
      (this.componentRef
        .instance as CorrespondenceReference).countries = this.countries;
    } else if (this.data === 'state') {
      (this.componentRef
        .instance as CorrespondenceReference).countries = this.countries;
      (this.componentRef
        .instance as CorrespondenceReference).states = this.states;
    } else if (this.data === 'lga') {
      (this.componentRef
        .instance as CorrespondenceReference).states = this.states;
      (this.componentRef.instance as CorrespondenceReference).lgas = this.lgas;
    } else if (this.data === 'actionParty') {
      (this.componentRef
        .instance as CorrespondenceReference).teams = this.teams;
      (this.componentRef
        .instance as CorrespondenceReference).actionParties = this.actionParties;
    } else if (this.data === 'team') {
      (this.componentRef
        .instance as CorrespondenceReference).teams = this.teams;
    } else if (this.data === 'function') {
      (this.componentRef
        .instance as CorrespondenceReference).functions = this.functions;
      (this.componentRef
        .instance as CorrespondenceReference).companies = this.companies;
    } else if (this.data === 'requestCategory') {
      (this.componentRef
        .instance as CorrespondenceReference).functions = this.functions;
      (this.componentRef
        .instance as CorrespondenceReference).requestCategories = this.requestCategories;
    } else if (this.data === 'issuedCategory') {
      (this.componentRef
        .instance as CorrespondenceReference).issuedCategories = this.issuedCategories;
    } else if (this.data === 'company') {
      (this.componentRef
        .instance as CorrespondenceReference).companies = this.companies;
    } else if (this.data === 'community') {
      (this.componentRef.instance as CorrespondenceReference).lgas = this.lgas;
      (this.componentRef
        .instance as CorrespondenceReference).communities = this.communities;
    } else if (this.data === 'currency') {
      (this.componentRef
        .instance as CorrespondenceReference).currencies = this.currencies;
    }

    /** @Output data from our instance  */
    this.componentRef.instance.changeEmit.subscribe((data) =>
      this.changeEmit.emit(data)
    );

    this.componentRef.instance.deleteEvent.subscribe((data) =>
      this.deleteEvent.emit(data)
    );
  }
}
